// Tri-colour "Lions stripe" (gold, orange, blue): the school-spirit accent that
// opens each band on the homepage and sits under every page hero. Decorative.
const LionsStripe = ({ className = '' }) => (
  <div aria-hidden="true" className={`flex h-2 ${className}`}>
    <span className="flex-1 bg-accent-yellow"></span>
    <span className="flex-1 bg-secondary"></span>
    <span className="flex-1 bg-navy-400"></span>
  </div>
);

export default LionsStripe;
